import React, { ReactNode, useState } from "react";
import { CursorState } from "../../providers/CursorProvider";
import { CursorComponent } from "./CursorComponent";

interface SmashchangeProps {
    pre: ReactNode;
    post: ReactNode;
    className ?: string;
    style ?: React.CSSProperties;
}

export function Smashchange (props : SmashchangeProps) {
    const [smashed, setSmashed] = useState(false);

    const className = props.className !== undefined ? props.className : "";
    const style = props.style !== undefined ? props.style : {};

    return smashed 
        ? <div
            className={className}
            style={style}>
            { props.post }
        </div> 
        : <CursorComponent 
            cursor={CursorState.HAM}
            onClick={() => { setSmashed(true); }}
            className={className}
            style={style}>
            { props.pre }
        </CursorComponent>
}